"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BaseButton_1 = __importDefault(require("./BaseButton"));
const clsx_1 = __importDefault(require("clsx"));
const TextButton = ({ label, ...props }) => {
    return (react_1.default.createElement(BaseButton_1.default, Object.assign({}, props, { className: clsx_1.default('disabled:text-gray-500 hover:text-highlight-500 text-highlight-600 font-medium disabled:cursor-not-allowed transition duration-150 ease-in-out') }), label));
};
exports.default = TextButton;
